import { HostProps } from '@economic/react-app';

export const DATADOG_CONFIG = {
    applicationId: 'aa62366e-0973-4f24-b6bb-b52bf88fa425',
    clientToken: 'pub2fd1f64a409d19e7277f19765c95d122',
} satisfies HostProps['configuration']['datadog'];
